<template>
  <StyledCasinoButton
    ref="targetEl"
    class="casino-button"
    :text="text"
    :buttonId="buttonId"
    @click.stop="handleClick"
  />
</template>

<script lang="ts">
import { composePopoverForm } from "@fresh8/ad-data-composition/src/popoverForm";
import { injectBrand } from "@fresh8/ad-data-composition/src/brand";
import { defineComponent, computed } from "vue";
import StyledCasinoButton from "../../styled/CasinoButton.vue";
import { injectCardNumber, useAnalytics } from "../../../hooks/useAnalytics";
import { getCtaButton } from "../../../hooks/useCtaButton";
import { createUseStyles } from "@fresh8/vue-jss/src";

const useStyles = createUseStyles({});

export default defineComponent({
  name: "CasinoCtaButton",
  components: {
    StyledCasinoButton
  },
  props: {
    optionName: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: true
    }
  },
  setup(props) {
    const brandContext = injectBrand();
    const cardNumber = injectCardNumber();

    const { handleClick } = useAnalytics(
      { cardNumber, optionName: props.optionName },
      "Casino CTA"
    );

    const ctaButton = computed(() => getCtaButton());

    const buttonId = computed({
      get() {
        if (brandContext?.brand.value) {
          return (
            brandContext.brand.value.adTemplate.casino?.button ||
            brandContext.brand.value.adTemplate.market.casinoCTAButton ||
            ctaButton.value.id
          );
        }
        return "";
      },
      set(value: string) {
        if (
          brandContext?.brand.value &&
          brandContext.brand.value.adTemplate.casino?.button
        ) {
          brandContext.brand.value.adTemplate.casino.button = value;
        }
      }
    });

    const { targetEl } = composePopoverForm("Casino CTA Button", [
      {
        type: "ctaButton",
        get: () => buttonId.value,
        set: (value: string) => {
          buttonId.value = value;
        }
      }
    ]);

    const classes = useStyles();

    return {
      classes,
      buttonId,
      targetEl,
      handleClick
    };
  }
});
</script>

<style></style>
